import React, { useCallback, useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";
import { Link } from "react-router-dom";
import ToastMessage from "../../ToastMessage";

const BrowseRecharge = () => {
  const {PaymentStatusMap} = useContext(AuthContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [totalRecharge, setTotalRecharge] = useState(null);

  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Open image in modal/popup
  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  // Close image modal/popup
  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  // handle success recharge
  const handleSuccessRech = async(id , amount) => {
    try {
      const auth = localStorage.getItem('admin');
      const res = await axios.post(`${base_url}/api/webapi/admin/recharge/status`,
        {id,amount ,  status: PaymentStatusMap.SUCCESS},
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            Authorization: `${auth}`
          }
        }
      );
      if(res.data.status) {
        ToastMessage(1, res.data.message);
        const updatedRecharge = totalRecharge.filter((item) => item.id !== id);
        setTotalRecharge(updatedRecharge);
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch(err) {
      ToastMessage(0, "error");
    }
  };
  
  const handleCancelRecharge = async(id) => {
    try {
      const auth = localStorage.getItem('admin');
      const res = await axios.post(`${base_url}/api/webapi/admin/recharge/status`,
        {id, status: PaymentStatusMap.CANCELLED},
        {
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      );
      if(res.data.status) {
        ToastMessage(1, res.data.message);
        const updatedRecharge = totalRecharge.filter((item) => item.id !== id);
        setTotalRecharge(updatedRecharge);
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch(err) {
      ToastMessage(0, "error"); 
    }
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem('admin');
    const role = localStorage.getItem('role');

    try {
      const roles = await getRoles(auth, role);

      roles.map((role) => {
        const values = Object.values(role);

        values[0].map((val) => {
          if(Object.keys(val).includes('pending recharge')) {
            const permit = Object.values(val);
            setPermit(permit[0]);
          }
        });
      });
    } catch(error) {
      console.log('ert', error);
    }
  };
  
  useEffect(() => {
    const fetchRechargeRecord = async () => {
      try {
        const auth = localStorage.getItem('admin');
        const res = await axios.get(
          `${base_url}/api/webapi/admin/recharge/pending`,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              Authorization: `${auth}`
            },
          }
        );

        console.log("response is ", res.data);

        // console.log(res, "resdcn");
        setTotalRecharge(res.data.list);
      } catch (err) {
        ToastMessage(0, 'error');
      }
    };
    fetchRechargeRecord();
    fetchRoles();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
      {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        /> */}
        
        {/* Header - Pass mobile info */}
        {/* <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Pending Recharge</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Pending Recharge</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    title="Remove"
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <div className=" table-responsive card-body p-0" style={{ overflowY: "hidden" }}>
                <table className=" table table-responsive-sm table-striped projects">
                  <thead className="bg-gray">
                    <tr className="border">
                      <th className="text-center border px-3 text-nowrap">#</th>
                      <th className="text-center border px-3 text-nowrap">Account</th>
                      <th className="text-center border px-3 text-nowrap">Amount</th>
                      <th className="text-center border px-3 text-nowrap">Code</th>
                      <th className="text-center border px-3 text-nowrap">UTR</th>
                      <th className="text-center border px-3 text-nowrap">Proof</th>
                      <th className="text-center border px-3 text-nowrap">Method</th>
                      <th className="text-center border px-3 text-nowrap">Request Time</th>
                      <th className="text-center border px-3 text-nowrap">Status</th>
                      <th className="text-center border px-3 text-nowrap">Accept/Reject</th>
                    </tr>
                  </thead>
                  <tbody>
                    {totalRecharge?.map((e, i) => (
                      <tr className="text-center border px-3 text-nowrap" key={i}>
                        <td>{e.id}</td>
                        <td className="text-center border px-3 text-nowrap">
                          <b>{e.phone}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap">
                          <b>{e.money}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap" style={{ minWidth: 190 }}>
                          <b>{e.id_order}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap" style={{ minWidth: 190 }}>
                          <b>{e.utr}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap" style={{ minWidth: 190 }}>
                          {e.url ? (
                            <>
                              <div className="image-thumbnail">
                                <img 
                                  src={`${base_url}${e.url}`} 
                                  alt="Payment Proof" 
                                  style={{ 
                                    width: '60px', 
                                    height: '60px', 
                                    objectFit: 'cover', 
                                    cursor: 'pointer' 
                                  }}
                                  onClick={() => openImageModal(`${base_url}${e.url}`)}
                                />
                              </div>
                              <div className="mt-1">
                                <small 
                                  className="text-primary" 
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => openImageModal(`${base_url}${e.url}`)}
                                >
                                  View Full
                                </small>
                              </div>
                            </>
                          ) : (
                            <span>No proof uploaded</span>
                          )}
                        </td>
                        <td className="text-center border px-3 text-nowrap" style={{ minWidth: 190 }}>
                          <b style={{ color: "#a50064" }}>{e.type}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap" style={{ minWidth: 190 }}>
                          <b>{e.today}</b>
                        </td>
                        <td className="text-center border px-3 text-nowrap">
                          <span className="badge badge-warning">
                            Waiting...
                          </span>
                        </td>
                        <td
                          className="d-flex gap-2 justify-content-center project-actions text-center border px-3 text-nowrap"
                          style={{ minWidth: 160 }}
                        >
                          <Link
                            className={`btn btn-success btn-sm confirm-btn ${permit.includes('Accept Recharge') ? 'd-block' : 'd-none'}`}
                            onClick={() => handleSuccessRech(e.id , e.money)}
                          >
                            <i className="fa fa-check" />
                          </Link>
                          <Link
                            className={`btn btn-danger btn-sm delete-btn ${permit.includes('Reject Recharge') ? 'd-block' : 'd-none'}`}
                            onClick={() => handleCancelRecharge(e.id)}
                          >
                            <i className="fas fa-trash" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Image Modal */}
      {showImageModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Proof</h5>
                <button type="button" className="close" onClick={closeImageModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                <img 
                  src={selectedImage} 
                  alt="Payment Proof" 
                  style={{ maxWidth: '100%' }} 
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeImageModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BrowseRecharge;